import React, { useState } from 'react';
import { cn } from '@/lib/utils';

const CommonModal = ({ modelTitle, openModel, handleModelClose, addonsClass = '', modelHeaderHide = false, children }) => {
    return (
        <div className={cn('modal', addonsClass, openModel && 'active')}>
            {modelHeaderHide && modelHeaderHide == true ? (
                <>{children}</>
            ) : (
                <div className="modal-dialog">
                    <div className="modal-header">
                        <h3 className="modal-title">{modelTitle}</h3>
                        <button className="modal-close fa-regular fa-circle-xmark" onClick={() => handleModelClose()}></button>
                    </div>
                    <div className="modal-body">{children}</div>
                </div>
            )}
        </div>
    );
};

export default CommonModal;
